<script setup>
    import LucideIcon from './LucideIcon.vue'
</script>
<template>
    <LucideIcon name="ShoppingCart"/>
</template>